import { render, staticRenderFns } from "./animation-effects.vue?vue&type=template&id=ecfd23a2"
import script from "./animation-effects.vue?vue&type=script&lang=js"
export * from "./animation-effects.vue?vue&type=script&lang=js"
import style0 from "./animation-effects.vue?vue&type=style&index=0&id=ecfd23a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports